import polyglotI18nProvider from 'ra-i18n-polyglot'
import { DataProvider } from 'react-admin'
import * as domainMessages from 'react-admin-import-csv/lib/i18n'
import { i18nDutch, i18nEnglish, i18nNorwegian } from '../i18n'
import { getEnvVariable } from '../utils/getEnvVariable'
import authProvider from './auth'
import { getUrl, xxllncDataProvider } from './data'

const getDataProvider = (): DataProvider => xxllncDataProvider

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const messages: Record<string, any> = {
  en: { ...i18nEnglish, ...domainMessages.en },
  nl: { ...i18nDutch, ...domainMessages.nl },
  no: { ...i18nNorwegian, ...domainMessages.en },
}

export const LOCALE_KEY = 'sa_locale'

const detectLocale = (): string => {
  const stored = localStorage.getItem(LOCALE_KEY)
  if (stored && ['en', 'nl', 'no'].includes(stored)) return stored

  const langs = navigator.languages || [navigator.language]
  for (const lang of langs) {
    const code = lang.toLowerCase()
    if (code.startsWith('nl')) return 'nl'
    if (code.startsWith('nb') || code.startsWith('nn') || code === 'no') return 'no'
  }
  return 'en'
}

const i18nProvider = polyglotI18nProvider(
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return,security/detect-object-injection
  (locale: string) => messages[locale] ?? messages.en,
  detectLocale()
)

const providers = {
  auth: authProvider,
  data: getDataProvider(),
  i18n: i18nProvider,
  url: getUrl(),
}

export default providers
